import { styled } from '@mui/material/styles';

export const StyledListItem = styled('li')({
  listStyleType: 'none',
});
